// extracted by mini-css-extract-plugin
module.exports = {"title":"y_l","cards":"y_v"};